import moment from 'moment';
import { SIMPLE_DATE_FORMAT_STRING_NO_SECONDS } from '../store/common/constants';

const datePickerService = {
    parseTimeFromUTC(date: string): string {
        const selectedDate = `${moment(date).format('YYYYMMDD')}2359`;
        return moment(selectedDate, SIMPLE_DATE_FORMAT_STRING_NO_SECONDS).utc(false).format(SIMPLE_DATE_FORMAT_STRING_NO_SECONDS);
    },

    parseTimeFromUTCHumanized(
        date: string,
        format = 'Do MMMM YYYY'
    ): string {
        return moment.utc(date, SIMPLE_DATE_FORMAT_STRING_NO_SECONDS).local().format(format);
    },
};
export default datePickerService;
